
import { Condition, ConditionalValue, TField as TFieldNew } from "../components/forms/DynamicFormNew";
import { TField } from "../components/forms/DynamicForm";
import { AADHAR_REGEX, COUNTRIES, GSTIN_REGEX, MOBILE_NUMBER_REGEX, PAN_REGEX, STATES, STATE_CODES } from "../utils/constant";

export interface ICustomer {
    id: string;
    basicDetails: ICustomerBasic;
    nominee: ICustomerNominee;
    kycInfo: ICustomerKyc;
    addresses: ICustomerAddress[];
    accounts: ICustomerAccount[];
    currencies: ICustomerCurrency[];
    functions: ICustomerFunction[];
    limits: ICustomerLimits[];
    children: ICustomerBasic[];
}
export interface ICustomerSummary {
    customerRefNo: string;
    mobileNumber: string;
    emailAddress: string;
    fullName: string;
    mainAccountNo: string;
    partnerId?: string;
    isCorporate: string | boolean;
    isActive?: boolean;
    kycStatus: string;
    userType: string;
    kycInfo?: ICustomerKyc | undefined;
    imageUrl?: string;
    jobworkMetalReturnPerc?: string;
    buysellMetalReturnPerc?: string;
    purityVerificationCharges?: string;
    children?: ICustomerSummary[]
    dgCustomerRefNo?: string
}
export interface ICustomerNominee {
    name: string;
    dgCustomerRefNo?: string;
    mobileNumber: string;
    dob?: string;
    relationship: string;
    govtIdType: string;
    govtIdNumber: string;
    guardianName: string;
    guardianMobileNumber: string;
    emailAddress?: string;
    guardianDob: string;
    createdAt?: string;
    updateddAt?: string;
}
export interface ICustomerBasic {
    uid?: string;
    fullName: string;
    mobileNumber: string; //
    customerRefNo?: string;
    dgCustomerRefNo?: string;
    kycStatus: string;
    isCorporate: string;
    gstin: string; //
    type: string;
    mainAccountNo: string; //
    emailAddress?: string; //
    createdAt?: string;
    updateddAt?: string;
    partnerId?: string;
    accountStatus: string;
    platform: string;
    maritalStatus: string;
    dob?: string;
    profession: string;
    displayName: string;
    imageUrl?: string;
    jobworkMetalReturnPercentage?: number;
    jobworkPgmMetalReturnPercentage?: number;
    buysellMetalReturnPercentage?: number;
    buysellPgmMetalReturnPercentage?: number;
    buybackMetalReturnPercentage?: number;
    purityVerificationCharges?: number;
    refiningCharges?: number;
    saperateCharges?: boolean;
    gender: string;
    nationality: string;
    sendPromotions: string | boolean;
    emailStatus: string
    userType: string;
    employeeCode?: string;
    pan?: string;
    walletBalance: number;
    kycInfo?: any,
    mtsIsTDSApplicable?:string
}
export interface ICustomerAddress {
    id: string;
    name: string;
    line1: string;
    line2: string;
    city: string;
    state: string;
    zip: number;
    country: string;
    mobileNumber: string;
    stateCode: string;
    type: string;
    isActive: boolean;
    customerRefNo?: string;
}
export interface ICustomerBankAccount {
    name: string;
    type?: string;
    customerRefNo: string;
    accountNumber: string;
    ifscCode: string;
    vpaId: string;
    id: string;
}

export interface ICustomerAccount {
    accountNo: string;
    description: string;
    currency: string;
    location: string;
    creditLimit: string;
    deliveryLimit: string;
    isAllocated: boolean;
    id: string;
}
export interface ICustomerKyc {
    dg_customer_ref_no: string;
    nameProofDocType?: string,
    nameProofType?: string,
    nameProofDocNo?: string,
    nameProofDocUrl?: string,
    addressProofDocType?: string,
    addressProofDocNo?: string,
    addressProofDocUrl?: string,
    addressProofType?: string
}

export interface ICustomerCurrency {
    currencyPair: string;
    defaultValueDays: number;
    isTradable: boolean;
    id: string;
}
export interface ICustomerFunction {
    functionKey: string;
    functionValue: string;
    id: string;
}
export interface ICustomerLimits {
    limitValue: string;
    limitType: string;
    id: string;
}


export const CUSTOMER_FORM_CONFIG: TFieldNew<ICustomerBasic>[] = [
    {
        fieldName: 'fullName',
        isVisible: true,
        fieldType: 'text',
        label: 'Name',
        fullWidth: false,
        validation:{
            required:true,
            maxLength:50
        },
        width: 'calc(33% - 20px)'
    },
    {
        fieldName: 'displayName',
        isVisible: true,
        fieldType: 'text',
        label: 'Display Name',
        fullWidth: false,
        validation:{
            required:true,
            maxLength:100
        },
        width: 'calc(33% - 20px)'
    },
    {
        fieldName: 'mobileNumber',
        isVisible: true,
        fieldType: 'text',
        label: 'Mobile Number',
        fullWidth: false,
        disabled:true,
        validation:{
            required:true,
            regex: MOBILE_NUMBER_REGEX
        },
        width: 'calc(33% - 20px)'
    },
    {
        fieldName: 'mainAccountNo',
        isVisible: true,
        fieldType: 'text',
        label: 'Main Account Number/Phone No.',
        fullWidth: false,
        validation:{
            maxLength:30
        },
        width: 'calc(33% - 20px)'
    },
    {
        fieldName: 'partnerId',
        isVisible: true,
        fieldType: 'autocomplete',
        label: 'Partner Customer',
        fullWidth: false,
        options: [{ value: "mpipl", label: 'MPIPL' }],
        validation:{
            required:true,
        },
        width: 'calc(33% - 20px)'
    },
    {
        fieldName: 'emailAddress',
        isVisible: true,
        fieldType: 'text',
        label: 'Customer Email',
        fullWidth: false,
        validation:{
            maxLength:30,
            email:true
        },
        width: 'calc(33% - 20px)'
    },
    {
        fieldName: 'accountStatus',
        isVisible: true,
        fieldType: 'autocomplete',
        label: 'Status',
        fullWidth: false,
        options: [{ value: "active", label: 'Active' }, { value: "inactive", label: 'Incative' }],
        validation:{
            required:true
        },
        width: 'calc(33% - 20px)'
    },
    {
        fieldName: 'profession',
        isVisible: true,
        fieldType: 'text',
        label: 'Profession',
        fullWidth: false,
        validation:{
            maxLength:30
        },
        width: 'calc(33% - 20px)'
    },
    {
        fieldName: 'dob',
        isVisible: true,
        fieldType: 'date',
        label: 'Date Of Birth',
        fullWidth: false,
        width: 'calc(33% - 20px)'
    },
    {
        fieldName: 'maritalStatus',
        isVisible: true,
        fieldType: 'autocomplete',
        label: 'Marital Status',
        fullWidth: false,
        options: [{ value: "married", label: 'Married' }, { value: "unmarried", label: 'Unmarried' }],
        width: 'calc(33% - 20px)'
    },
    {
        fieldName: 'gender',
        isVisible: true,
        fieldType: 'select',
        label: 'Gender',
        fullWidth: false,
        options: [{ value: "male", label: 'Male' }, { value: "female", label: 'Female' }, {value: 'other', label: 'Other'}],
        validation:{
            required:true
        },
        width: 'calc(33% - 20px)'
    },
    {
        fieldName: 'nationality',
        isVisible: true,
        fieldType: 'autocomplete',
        label: 'Nationality',
        fullWidth: false,
        validation:{
            required:true,
            maxLength:30
        },
        width: 'calc(33% - 20px)',
        options: COUNTRIES,
    },
    {
        fieldName: 'userType',
        isVisible: true,
        fieldType: 'select',
        label: 'User Type',
        fullWidth: false,
        options: [{ value: "regular", label: 'Regular' }, { value: "employee", label: 'Employee' }, { value: "F&F", label: 'Friends & Family' }],
        validation:{
            required:true
        },
        width: 'calc(33% - 20px)'
    },
    {
        fieldName: 'employeeCode',
        isVisible: false,
        fieldType: 'text',
        label: 'Employee Code',
        fullWidth: false,
        width: 'calc(33% - 20px)'
    },
    {
        fieldName: 'gstin',
        isVisible: true,
        fieldType: 'text',
        label: 'GSTIN',
        fullWidth: false,
        validation:{
            minLength:15,
            maxLength:15,
            regex: GSTIN_REGEX
        },
        width: 'calc(33% - 20px)'
    },
    {
        fieldName: 'kycStatus',
        isVisible: false,
        fieldType: 'autocomplete',
        label: 'KYC Status',
        fullWidth: false,
        options: [{ value: "Y", label: 'Validated' }, { value: "I", label: 'Invalidate' }, { value: "P", label: 'Pending' }],
        width: 'calc(33% - 20px)'
    },
    {
        fieldName: 'isCorporate',
        isVisible: false,
        fieldType: 'select',
        label: 'Customer Type',
        fullWidth: false,
        width: 'calc(33% - 20px)',
        options: [{ value: "Y", label: 'B2B' }, { value: "N", label: 'B2C' }],
        value: 'N'
    },
    {
        fieldName: 'sendPromotions',
        isVisible: true,
        fieldType: 'checkbox',
        label: 'Send Promotions',
        fullWidth: false,
        width: 'calc(33% - 20px)'
    },
]

export const CUSTOMER_NOMINEE_FORM_CONFIG: TFieldNew<ICustomerNominee>[] = [
    {
        fieldName: 'name',
        isVisible: true,
        fieldType: 'text',
        label: 'Name',
        fullWidth: false,
        validation:{
            required:true,
            maxLength:50
        },
        width: 'calc(33% - 20px)'
    },
    {
        fieldName: 'emailAddress',
        isVisible: true,
        fieldType: 'text',
        label: 'Email Address',
        fullWidth: false,
        validation:{
            required:true,
            maxLength:30,
            email:true
        },
        width: 'calc(33% - 20px)'
    },
    {
        fieldName: 'relationship',
        isVisible: true,
        fieldType: 'text',
        label: 'Relationship',
        fullWidth: false,
        validation:{
            required:true,
            maxLength:30
        },
        width: 'calc(33% - 20px)'
    },
    {
        fieldName: 'mobileNumber',
        isVisible: true,
        fieldType: 'text',
        label: 'Mobile Number',
        fullWidth: false,
        numbersOnly:true,
        validation:{
            required:true,
            // maxLength:10,
            // minLength:10,
            regex : MOBILE_NUMBER_REGEX
        },
        width: 'calc(33% - 20px)'
    },
    {
        fieldName: 'dob',
        isVisible: true,
        fieldType: 'date',
        label: 'DOB',
        fullWidth: false,
        validation:{
            required:true
        },
        width: 'calc(33% - 20px)'
    },
    {
        fieldName: 'govtIdType',
        isVisible: true,
        fieldType: 'autocomplete',
        label: 'Govt ID Type',
        fullWidth: false,
        options: [{ value: "PAN", label: 'PAN' }, { value: "AADHAR", label: 'AADHAR' }],
        validation:{
            required:true
        },
        width: 'calc(33% - 20px)'
    },
    {
        fieldName: 'govtIdNumber',
        isVisible: true,
        fieldType: 'text',
        label: 'Govt Id Number',
        fullWidth: false,
        validation:{
            required:true,
            maxLength: new ConditionalValue([
            {
                value: 10,
                condition: {fieldName:'govtIdType', operator: 'eq', value: 'PAN'}
            },
            {
                value: 12,
                condition: {fieldName:'govtIdType', operator: 'eq', value: 'AADHAR'}
            }
        ]),
            minLength: new ConditionalValue([
                {
                    value: 10,
                    condition: {fieldName:'govtIdType', operator: 'eq', value: 'PAN'}
                },
                {
                    value: 12,
                    condition: {fieldName:'govtIdType', operator: 'eq', value: 'AADHAR'}
                }
            ]),
            regex: new ConditionalValue([
                {
                    value: PAN_REGEX,
                    condition: {fieldName:'govtIdType', operator: 'eq', value: 'PAN'}
                },
                {
                    value: AADHAR_REGEX,
                    condition: {fieldName:'govtIdType', operator: 'eq', value: 'AADHAR'}
                }
                
            ])
        },
        width: 'calc(33% - 20px)'
    },
    {
        fieldName: 'guardianName',
        isVisible: true,
        fieldType: 'text',
        label: 'Guardian Name',
        fullWidth: false,
        validation:{
            required:true,
            maxLength:50
        },
        width: 'calc(33% - 20px)'
    },
    {
        fieldName: 'guardianMobileNumber',
        isVisible: true,
        fieldType: 'text',
        label: 'Guardian Mobile Number',
        fullWidth: false,
        numbersOnly:true,
        validation:{
            required:true,
            regex : MOBILE_NUMBER_REGEX
        },
        width: 'calc(33% - 20px)'
    },
    {
        fieldName: 'guardianDob',
        isVisible: true,
        fieldType: 'date',
        label: 'Guardian DOB',
        fullWidth: false,
        validation:{
            required:true
        },
        width: 'calc(33% - 20px)'
    }
]

export const CUSTOMER_KYC_FORM_CONFIG: TField<ICustomerKyc>[] = [
    // {
    //     fieldName: 'dg_customer_ref_no',
    //     isVisible: true,
    //     fieldType: 'text',
    //     label: 'Customer Ref No',
    //     fullWidth: false
    // },
    {
        fieldName: 'nameProofDocType',
        isVisible: true,
        fieldType: 'text',
        label: 'Name Proof Type',
        fullWidth: false
    },
    {
        fieldName: 'nameProofDocNo',
        isVisible: true,
        fieldType: 'text',
        label: 'Name Proof Doc No',
        fullWidth: false
    },
    {
        fieldName: 'addressProofDocType',
        isVisible: true,
        fieldType: 'text',
        label: 'Address Proof Type',
        fullWidth: false
    },
    {
        fieldName: 'addressProofDocNo',
        isVisible: true,
        fieldType: 'text',
        label: 'addressProofDocNo',
        fullWidth: false
    },
]

export const AddressTypes = [
    { value: 'D', label: 'Ship To' }, 
    { value: 'B', label: 'Bill To' } 
]


export const ADDRESS_FORM_CONFIG: TFieldNew<ICustomerAddress>[] = [
    {
        fieldName: 'name',
        isVisible: true,
        fieldType: 'text',
        label: 'Adress Nickname',
        fullWidth: false,
        validation:{
            required:true,
            maxLength:50
        }
    },
    {
        fieldName: 'type',
        isVisible: true,
        fieldType: 'autocomplete',
        label: 'Type',
        fullWidth: false,
        options: AddressTypes,
        validation:{
            required:true
        }
    },
    {
        fieldName: 'line1',
        isVisible: true,
        fieldType: 'text',
        label: 'Address Line 1',
        fullWidth: false,
        validation:{
            required:true,
            maxLength:100
        }
    }, 
    {
        fieldName: 'line2',
        isVisible: true,
        fieldType: 'text',
        label: 'Address Line 2',
        fullWidth: false,
        validation:{
            maxLength:100
        }
    }, 
    {
        fieldName: 'mobileNumber',
        isVisible: true,
        fieldType: 'text',
        label: 'Mobile',
        fullWidth: false,
        numbersOnly:true,
        validation:{
            required:true,
            regex : MOBILE_NUMBER_REGEX
        }
    },
    {
        fieldName: 'city',
        isVisible: true,
        fieldType: 'autocomplete',
        label: 'City',
        fullWidth: false,
        options:[] ,
        validation:{
            required:true,
            maxLength:30
        },
        freeSolo : true
    },
    {
        fieldName: 'state',
        isVisible: true,
        fieldType: 'autocomplete',
        label: 'State',
        fullWidth: false,
        options: [] ,
        validation:{
            required:true
        },
        freeSolo : false

    },
    {
        fieldName: 'zip',
        isVisible: true,
        fieldType: 'text',
        label: 'Zipcode',
        fullWidth: false,
        numbersOnly:true,
        validation:{
            required:true,
            minLength:6,
            maxLength:6
        }
    },
    {
        fieldName: 'country',
        isVisible: true,
        fieldType: 'text',
        label: 'Country',
        width: 'calc(33% - 20px)',
        defaultValue : "INDIA",
        value : "India",
        disabled : true
    },
    {
        fieldName: 'isActive',
        isVisible: false,
        fieldType: 'switch',
        label: 'Is Active?',
        fullWidth: false
    }
    
]

export const ACCOUNT_FORM_CONFIG: TField<ICustomerAccount>[] = [
    {
        fieldName: 'accountNo',
        isVisible: true,
        fieldType: 'text',
        label: 'Account No',
        fullWidth: false,
        isRequired: true
    },
    {
        fieldName: 'description',
        isVisible: true,
        fieldType: 'text',
        label: 'Description',
        fullWidth: false,
        isRequired: true
    },
    {
        fieldName: 'currency',
        isVisible: true,
        fieldType: 'autocomplete',
        label: 'Currency',
        fullWidth: false,
        isRequired: true,
        options: [{ value: "rupee", label: 'Indian Rupee' }, { value: 'gold', label: 'Gold' }, { value: 'silver', label: 'Silver' }, { value: 'copper', label: 'Copper' }],
    },
    {
        fieldName: 'location',
        isVisible: true,
        fieldType: 'autocomplete',
        label: 'Location',
        fullWidth: false,
        isRequired: true,
        options: [{ value: "locoLondon", label: 'Loco London' }, { value: 'locoNewYork', label: 'Loco Newyork' }, { value: 'locoMmtcPamp', label: 'Loco MMTC Pamp' }],
    },
    {
        fieldName: 'creditLimit',
        isVisible: true,
        fieldType: 'text',
        label: 'Credit Limit',
        fullWidth: false,
        isRequired: true
    },
    {
        fieldName: 'deliveryLimit',
        isVisible: true,
        fieldType: 'text',
        label: 'Delivery Limit',
        fullWidth: false,
        isRequired: true
    },
    {
        fieldName: 'isAllocated',
        isVisible: true,
        fieldType: 'checkbox',
        label: 'Is Allocated',
        fullWidth: false,
        isRequired: true
    },
]

export const CURRENCY_FORM_CONFIG: TField<ICustomerCurrency>[] = [
    {
        fieldName: 'currencyPair',
        isVisible: true,
        fieldType: 'text',
        label: 'Currency Pair',
        fullWidth: false
    },
    {
        fieldName: 'defaultValueDays',
        isVisible: true,
        fieldType: 'number',
        label: 'Default Value Days',
        fullWidth: false
    },
    {
        fieldName: 'isTradable',
        isVisible: true,
        fieldType: 'checkbox',
        label: 'Is Tradable',
        fullWidth: false
    },
]

export const FUNCTION_FORM_CONFIG: TField<ICustomerFunction>[] = [
    {
        fieldName: 'functionKey',
        isVisible: true,
        fieldType: 'text',
        label: 'Function Key',
        fullWidth: false
    },
    {
        fieldName: 'functionValue',
        isVisible: true,
        fieldType: 'text',
        label: 'Function Value',
        fullWidth: false
    },
]

export const LIMITS_FORM_CONFIG: TField<ICustomerLimits>[] = [
    {
        fieldName: 'limitValue',
        isVisible: true,
        fieldType: 'text',
        label: 'Limit Value',
        fullWidth: false
    },
    {
        fieldName: 'limitType',
        isVisible: true,
        fieldType: 'text',
        label: 'Limit Type',
        fullWidth: false
    },
]

export type TRow<T> = {
    id: keyof T | 'actions' | 'pan' | 'aadhar' | 'panDownload';
    label: string;
}
// Table column
export const CUSTOMER_DETAIL_FIELDS: TRow<ICustomerSummary>[] = [
    {
        id: "actions",
        label: 'Actions',
    },
    {
        id: "pan",
        label: 'PAN',
    },
    {
        id: "panDownload",
        label: "PAN Download"
    },
    {
        id: "aadhar",
        label: 'Aadhar',
    },
    {
        id: "customerRefNo",
        label: 'Customer Ref Number',
    },
    {
        id: "fullName",
        label: 'Customer Name',
    },
    {
        id: "mobileNumber",
        label: 'Mobile',
    },
    {
        id: "emailAddress",
        label: 'Email',
    },
    {
        id: "mainAccountNo",
        label: 'Main Account Number',
    },
    {
        id: "partnerId",
        label: 'Partner',
    },
    {
        id: "kycStatus",
        label: 'KYC Status',
    },
    {
        id: "kycInfo",
        label: 'Pan Number'
    },
    {
        id: "isCorporate",
        label: 'Is Corporate',
    },
    {
        id: "userType",
        label: 'Type',
    },
]

export const CUSTOMER_KYC_FIELDS = [
    {
        id: 'action',
        label: 'Action',
    },
    {
        id: 'nameProofType',
        label: 'Name Proof Type',
    },
    {
        id: 'nameProofDocNo',
        label: 'Name Proof Doc No',
    },
    {
        id: 'addressProofType',
        label: 'Address Proof Type',
    },
    {
        id: 'addressProofDocNo',
        label: 'Address Proof Doc No',
    },
]
export const CUSTOMER_NOMINEE_FIELDS = [
    {
        id: 'action',
        label: 'Action',
    },
    {
        id: 'name',
        label: 'Name',
    },
    {
        id: 'mobileNumber',
        label: 'Mobile Number',
    },
    {
        id: 'dob',
        label: 'DOB',
    },
    {
        id: 'relationship',
        label: 'Relationship',
    },
    {
        id: 'govtIdType',
        label: 'Govt Id Type',
    },
    {
        id: 'govtIdNumber',
        label: 'Govt Id Number',
    },
    {
        id: 'guardianName',
        label: 'Guardian Name',
    },
    {
        id: 'guardianMobileNumber',
        label: 'Guardian Mobile Number',
    },
    {
        id: 'emailAddress',
        label: 'Email Address',
    },
    {
        id: 'guardianDob',
        label: 'Guardian DOB',
    },
    {
        id: 'createdAt',
        label: 'Created At',
    },
    {
        id: 'updateddAt',
        label: 'Updated At',
    },
]
export const CUSTOMER_LIMITS_FIELDS = [
    {
        id: 'limitValue',
        label: 'Limit Value',
    },
    {
        id: 'limitType',
        label: 'Limit Type',
    },
    {
        id: 'action',
        label: 'Action',
    },
]

export const CUSTOMER_ACCOUNTS_FIELDS = [
    {
        id: 'accountNo',
        label: 'Account No',
    },
    {
        id: 'description',
        label: 'Description',
    },
    {
        id: 'currency',
        label: 'Currency',
    },
    {
        id: 'isAllocated',
        label: 'Is Allocated',
    },
    {
        id: 'location',
        label: 'Location',
    },
    {
        id: 'creditLimit',
        label: 'Credit Limit',
    },
    {
        id: 'deliveryLimit',
        label: 'Delivery Limit',
    },
    {
        id: 'currentBalance',
        label: 'Current Balance',
    },
    {
        id: 'fineness',
        label: 'Fineness',
    },
    {
        id: 'action',
        label: 'Action',
    },
]

export const CUSTOMER_FUNCTIONS_FIELDS = [
    {
        id: 'functionKey',
        label: 'Function Type',
    },
    {
        id: 'functionValue',
        label: 'Function Value',
    },
    {
        id: 'action',
        label: 'Action',
    },
]

export const CUSTOMER_PRODUCTS_FIELDS = [
    {
        id: 'itemNo',
        label: 'Item No',
    },
    {
        id: 'itemDescription',
        label: 'Item Description',
    },
    {
        id: 'brand',
        label: 'Brand',
    },
    {
        id: 'currency',
        label: 'Currency',
    },
    {
        id: 'productCategory',
        label: 'Product Category',
    },
    {
        id: 'sortOrder',
        label: 'Sort Order',
    },
    {
        id: 'isInclusion',
        label: 'Is Inclusion',
    },
    {
        id: 'setFavourite',
        label: 'Set Favourite',
    },
    {
        id: 'action',
        label: 'Action',
    },
]

export const CUSTOMER_USERS_FIELDS = [
    {
        id: 'name',
        label: 'Name',
    },
    {
        id: 'type',
        label: 'Type',
    },
    {
        id: 'email',
        label: 'Email',
    },
    {
        id: 'phone',
        label: 'Phone',
    },
    {
        id: 'mobile',
        label: 'Mobile',
    },
    {
        id: 'sharedWithOtherBU',
        label: 'Shared With Other BU',
    },
    {
        id: 'isActive',
        label: 'Is Active',
    },
    {
        id: 'createdDate',
        label: 'Created Date',
    },
    {
        id: 'action',
        label: 'Action',
    }
]

export const CUSTOMER_CURRENCYPAIRS_FILEDS = [
    {
        id: 'currencyPair',
        label: 'Currency Pair',
    },
    {
        id: 'isTradable',
        label: 'Is Tradable',
    },
    {
        id: 'defaultValueDays',
        label: 'Default Value Days',
    },
    {
        id: 'action',
        label: 'Action',
    },
]

export const CUSTOMER_ADDRESSES_FIELDS:TRow<ICustomerAddress>[] = [
    {
        id: 'actions',
        label: 'Actions',
    },
    {
        id: 'name',
        label: 'Address Nick-Name',
    },
    {
        id: 'type',
        label: 'Address Type',
    },
    {
        id: 'line1',
        label: 'Line 1',
    },
    {
        id: 'line2',
        label: 'Line 2',
    },
    {
        id: 'city',
        label: 'City',
    },
    {
        id: 'state',
        label: 'State',
    },
    {
        id: 'zip',
        label: 'Zipcode',
    },
    {
        id: 'country',
        label: 'Country',
    },
    {
        id: 'mobileNumber',
        label: 'Mobile',
    },
   
]
